import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import type { AddToCartResponseItem, AddToCartResultListDTO } from "~/features/cart/cart/api/AddToCart";
import type { QuoteCheckoutDTO } from "~/features/cart/cart/api/QuoteToCart";

interface QuoteToCartResponse {
  ok: boolean;
  responseItems: AddToCartResponseItem[];
}

export interface QuoteCheckoutListRequestDTO {
  items: QuoteCheckoutDTO[];
}

export function sendDataMultipleQuotes(data: QuoteCheckoutDTO[]): Promise<QuoteToCartResponse> {
  const request: QuoteCheckoutListRequestDTO = { items: data };
  return occFetch(occUrl("/quote/list/checkout"), {
    body: JSON.stringify(request),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  }).then(async (result) => {
    const responseBody: AddToCartResultListDTO | undefined = result.ok ? await result.json() : undefined;
    return {
      ok: result.ok,
      responseItems: responseBody?.items ?? [],
    };
  });
}
